module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {

	fox.registerWidget('GridStub', {
		
		configure: function(options) {
			var date = new Date();
			this.registerOptions('', {
				skipPreloader: true,
				'item': {
					id: 1,
					'sites.publishDate': date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate() + ' 00:00:00',
				},
				autoRender: true,
				'widgets.list': {
					widget: 'List',
					autoRender: true
				}
			});
			return this.callParent('configure', arguments);
		},

		init: function() {
			
			var listOptions = this.getOption('list'), collection = [];
			console.log(listOptions);
			if (listOptions) {
				if (listOptions.count) {
					for (var i = 1, l = listOptions.count; i <= l; i++) {
						collection.push(this.getOption('item'));
					}
				}
				listOptions.collection = collection;
				this.registerOptions('#list', this.getOption('list'));
			}
		}

	});

})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/gridStub.js
// module id = 837
// module chunks = 4